/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '../../../../../src/app/common/wizard/wizard-step.component';
var styles_WizardStepComponent = [];
export var RenderType_WizardStepComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_WizardStepComponent, data: {} });
export function View_WizardStepComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [], [[8, 'hidden', 0]], null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = !_co.isActive;
        _ck(_v, 1, 0, currVal_0);
    });
}
export function View_WizardStepComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'wizard-step', [], null, null, null, View_WizardStepComponent_0, RenderType_WizardStepComponent)), i0.ɵdid(114688, null, 0, i1.WizardStepComponent, [], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var WizardStepComponentNgFactory = i0.ɵccf('wizard-step', i1.WizardStepComponent, View_WizardStepComponent_Host_0, { title: 'title', hidden: 'hidden',
    isValid: 'isValid', showNext: 'showNext', showPrev: 'showPrev', showAfterComplete: 'showAfterComplete',
    firma: 'firma', checkBeforeNext: 'checkBeforeNext', isActive: 'isActive', showButtons: 'showButtons' }, { onNext: 'onNext', onPrev: 'onPrev', onComplete: 'onComplete', onCancel: 'onCancel', onPrint: 'onPrint',
    onNew: 'onNew', onFirma: 'onFirma' }, ['*']);
//# sourceMappingURL=wizard-step.component.ngfactory.js.map